import { InputType } from '@import/enums/input-type.enum';
import { ColumnType } from '@import/interfaces';

export const JobAndPayCompensationColumnTypes: ColumnType[] = [
    {
        label: 'Compensation Type',
        translatableLabel: 'import.columnTypes.compensationType',
        serializeName: 'salaries.frequency',
        input: InputType.options,
        options: [
            {
                label: 'Yearly',
                relatedLabels: ['Year'],
                translatableLabel: 'import.optionTypes.yearly',
                value: 'year',
            },
            {
                label: 'Hourly',
                relatedLabels: ['Hour'],
                translatableLabel: 'import.optionTypes.hourly',
                value: 'hour',
            },
        ],
        required: false,
        requiredWith: ['salaries'],
    },
    {
        label: 'Salary',
        relatedLabels: ['Compensation Amount', 'Salary / Hourly Rate', 'Hourly Rate', 'Rate'],
        translatableLabel: 'import.columnTypes.salary',
        serializeName: 'salaries.rate',
        input: InputType.number,
        required: false,
        requiredWith: ['salaries'],
    },
    {
        label: 'Compensation Effective Date',
        relatedLabels: [
            'Salary Date',
            'Salary Effective At',
            'Salary Effective Date',
            'Compensation Date',
            'Compensation Effective At',
            'Salary Start',
            'Salary Begin',
            'Compensation Start',
            'Compensation Begin',
        ],
        translatableLabel: 'import.columnTypes.compensationEffectiveDate',
        serializeName: 'salaries.effectiveAt',
        input: InputType.date,
        required: false,
        requiredWith: ['salaries'],
    },
    {
        label: 'Hours Per Week',
        relatedLabels: ['Compensation Hours Per Week'],
        translatableLabel: 'import.columnTypes.hoursPerWeek',
        serializeName: 'salaries.hoursPerWeek',
        input: InputType.number,
        required: false,
        requiredWith: ['salaries'],
    },
    {
        label: 'Vacation Pay Rate',
        relatedLabels: ['Vacation Pay', 'Vacation Pay %', 'VP', 'Vacation Pay Percentage'],
        translatableLabel: 'import.columnTypes.vacationPay',
        serializeName: 'salaries.vacationPayPercentage',
        input: InputType.number,
        required: false,
    },
];
